import * as React from "react";
import DetailGrid, { DetailGridItem } from "common/components/controls/DetailGrid";
import DetailGroup from "common/components/controls/DetailGroup";
import { formatDate } from "common/utils/FmtDate";
import { Prestup } from "common/api/Evidence/Clenove/Prestupy";
import PrestupyUtils from "common/utils/PrestupyUtils";

interface ZakladniUdajeProps {
    prestup: Prestup;
    je_to_clen: boolean;
}

class ZakladniUdaje extends React.PureComponent<ZakladniUdajeProps>{

    render() {
        const { prestup, je_to_clen } = this.props

        const zakStartuDatum = prestup.stav === PrestupyUtils.Stav_ZaplaceniOdst ? prestup.odst_termin : prestup.zak_startu_do;
        const zakStartu = prestup.zak_startu_do ? `do ${formatDate(zakStartuDatum)}` : "není";


        const items: DetailGridItem[] = [
            { label: 'Individuelní člen', show: !je_to_clen, content: `${prestup.clen_pr} ${prestup.clen_jm}, IDT ${prestup.clen_idt}` },
            { label: 'Přestup z', content: prestup.puv_klub_id ? prestup.puv_klub_naz : "divize" },
            { label: 'Přestup do', content: prestup.nov_klub_id ? prestup.nov_klub_naz : "divize" },
            { label: 'Datum zadání přestupu', content: formatDate(prestup.dat_porizeni) },
            { label: 'Datum provedení přestupu', content: prestup.dat_prestupu ? formatDate(prestup.dat_prestupu) : "neproveden" },
            { label: 'Zákaz startu', content: zakStartu },
        ];

        return <DetailGroup title="Základní údaje">
            <DetailGrid items={items} labelXS={4} />
        </DetailGroup>
    }
}

/*

 const zakStartuDatum = prestup.stav == stav.POTVRZENI_ODST ? prestup.odst_termin : prestup.zak_startu_do;
    const zakStartu = prestup.zak_startu_do ? `do ${getDatum(zakStartuDatum)}` : "není";
    return <DetailGroup title="Základní údaje">
        {je_to_clen ? null : <DetailRow title={'Individuelní člen'}
                                        content={`${prestup.clen_pr} ${prestup.clen_jm}, IDT ${prestup.clen_idt}`}/>}
        <DetailRow title={'Přestup z'} content={prestup.puv_klub_id ? prestup.puv_klub_naz : "divize"}/>
        <DetailRow title={'Přestup do'} content={prestup.nov_klub_id ? prestup.nov_klub_naz : "divize"}/>
        <DetailRow title={'Datum zadání přestupu'} content={getDatum(prestup.dat_porizeni)}/>
        <DetailRow title={'Datum provedení přestupu'}
                   content={prestup.dat_prestupu ? formatDate(prestup.dat_prestupu) : "neproveden"}/>
        <DetailRow title={'Zákaz startu'} content={zakStartu}/>
        <DetailRow title={''} content={null}/>
    </DetailGroup>;


*/

export default ZakladniUdaje;
